import styled from 'styled-components';
import {
  Alert,
  Autocomplete,
  TextField,
  Typography,
} from '@mui/material';

import { ReactComponent as AnnouncementIcon } from '../../../../../assets/icons/menuIcons/announcement.svg';
import colors from '../../../../../styles/colors';

const RecipientActionsContainer = styled.div`
  margin: 5px 0 20px 0;
  display: flex;
  justify-content: flex-end;
  row-gap: 10px;
  align-items: center;
`;

const StyledTypography = styled(Typography)`
  font-size: 12px;
`;

const StyledAnnouncementIcon = styled(AnnouncementIcon)`
  height: 20px;
  width: 20px;

  > path {
    stroke: ${colors.shades.secondary8};
  }
`;

const SelectOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 20px;
`;

const DeliveryContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 12px;
`;

const SectionLabel = styled(Typography)`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: ${colors.shades.gamma2};
  margin: 0 0 8px 0;
`;

const DateSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin: 10px 0;
  flex-wrap: wrap;
`;

const StyledAlert = styled(Alert)`
  margin: 15px 0;
`;

const CommunityAutoComplete = styled(Autocomplete)`
  width: 300px;

  .MuiInputBase-root {
    background-color: ${colors.base.alpha};
    font-size: 14px;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${colors.shades.secondary4};
  }
`;

const RecipientsNote = styled.div`
  margin-top: 6px;
  color: ${colors.shades.gamma10};
  font-size: 12px;
`;

const DateSelectorField = styled(TextField)`
  flex: 1;
  min-width: 150px;

  .MuiInputBase-root {
    background-color: ${colors.base.alpha};
    font-size: 14px;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${colors.shades.secondary4};
  }
`;

export {
  RecipientActionsContainer,
  StyledTypography,
  StyledAnnouncementIcon,
  SelectOptionsContainer,
  DeliveryContainer,
  SectionLabel,
  DateSelectorContainer,
  DateSelectorField,
  StyledAlert,
  CommunityAutoComplete,
  RecipientsNote,
};
